"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagersTeamsService = void 0;
class ManagersTeamsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns managers teams information.
     * @returns ManagersTeamResponse
     * @throws ApiError
     */
    getManagersTeams() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/teams/',
        });
    }
    /**
     * Creates a managers team.
     * @param requestBody
     * @returns UpsertManagerTeamResponse
     * @throws ApiError
     */
    createManagerTeam(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/teams/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns team information by id.
     * @param id managers team uuid
     * @returns ManagersTeamResponse
     * @throws ApiError
     */
    getManagerTeam(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/teams/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Updates mangager team information by id.
     * @param id managers team uuid
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    updateManagerTeam(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/teams/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes a manager team.
     * @param id managers team uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    deleteManagerTeam(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/teams/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns manager information by team id.
     * @param id managers team uuid
     * @returns ManagerResponse
     * @throws ApiError
     */
    getManagersByTeam(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/teams/{id}/managers',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Paginate manager teams information with filters and sort.
     * @param filtersjson filtersjson is the ListManagerTeamsRequestFilters stringify into a query param
     * @param page
     * @param count
     * @returns ListManagerTeamsRes
     * @throws ApiError
     */
    listManagerTeams(filtersjson, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/teams/get/list',
            query: {
                'filtersjson': filtersjson,
                'page': page,
                'count': count,
            },
        });
    }
}
exports.ManagersTeamsService = ManagersTeamsService;
